import gql from 'graphql-tag';
import FieldsEmployeePushNotification from "graphql/fields/FieldsEmployeePushNotification";
import FieldsMessage from "graphql/fields/FieldsMessage";

export default gql(`
	query employee_push_notification( $guid: String! ) {
		employee_push_notification( guid: $guid ) {
			${FieldsEmployeePushNotification}
			
			message {
				${FieldsMessage}
			}
		}
	}
`);

